import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";

export interface IntegerValidatorError {
  integer: true;
}

export const IntegerValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  const REGEX = "^\\d+$";
  const regexp = new RegExp(REGEX);
  return control.value === null || regexp.test(control.value)? null : { integer: true } as IntegerValidatorError;
};
